import Grid2 from '@mui/material/Unstable_Grid2';
import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import { checkIfPruefAssitenzNeedsToValidate } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import { formStrucProjektdatenPruefassistentGlobal } from 'src/utils/formStruc';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const ProjektDatenAntragEbusse: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	return (
		<>
			<ApplicationHeading title='Projektdaten' description={PLATZHALTER_TEXT} />
			<PruefAssistenz
				statusPath={P.Allgemein_Pruefung_Pruefstatus.path}
				hinweisPath={P.Allgemein_Pruefung_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Allgemein_Pruefung_Ueberarbeitet_Am.path}
				erledigtPath={P.Allgemein_Pruefung_Erledigt.path}
				formStruc={formStrucProjektdatenPruefassistentGlobal(application)}
			/>
			<Grid2 spacing={6} container>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={formStrucSpalte1()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={updatedReadOnly}
					/>
				</Grid2>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={formStrucSpalte2()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={updatedReadOnly}
					/>
				</Grid2>
			</Grid2>
		</>
	);
};

export default ProjektDatenAntragEbusse;

const formStrucSpalte1 = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [P.Allgemein_Projekttitel, { ...P.Allgemein_Kurzwort, maxCharLength: 12 }],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
const formStrucSpalte2 = () => {
	// autofold/fold_next
	let struc: FormStrucItem[] = [
		{
			fields: [P.Allgemein_Geplante_Projektlaufzeit_von, P.Allgemein_Geplante_Projektlaufzeit_bis],
			userProps: { columnToDivide: 2 },
		},
	];
	return struc;
};

export const getFormStrucProjektDatenAntragEbusse = (application: any) => {
	let result: FormStrucItem[] = [];
	result = concat(formStrucSpalte1(), formStrucSpalte2());

	if (checkIfPruefAssitenzNeedsToValidate(application, P.Allgemein_Pruefung_Pruefstatus.path, P.Allgemein_Pruefung_Erledigt.path)) {
		result = concat(formStrucProjektdatenPruefassistentGlobal(application), result);
	}
	return result;
};
